import { GzPolicyUiSettingsGridDataProvider } from '../../../../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/gridView/dataProvider/GzPolicyUiSettingsGridDataProvider';
import { Column, ColumnKeys } from './grid-config';
import { SetFiltersRequest } from '../../../../../../../../../../grid/types/common';
import { convertRegexFilterToStartsWithFilter } from '../../../../../../../../../common/policyPanel/uiSettings/gridTemplate/utils/filters-converters';
import { sortByColumn } from './utils/sorters';
import { ContentControlDataProtectionRuleLight } from '../../../../../../../utils/uiSettings/contentControl/content-control.types';

export class GzContentControlDataProtectionRulesLightGridDataProvider extends GzPolicyUiSettingsGridDataProvider<
  Column,
  ColumnKeys,
  ContentControlDataProtectionRuleLight
> {
  sortByColumnMethod(
    a: ContentControlDataProtectionRuleLight,
    b: ContentControlDataProtectionRuleLight,
    sortColumnName: string,
    sortDirection: string
  ): number {
    return sortByColumn(a, b, sortColumnName, sortDirection);
  }

  async setFilters(request: SetFiltersRequest<ColumnKeys>): Promise<{} | undefined> {
    // convert regex to startsWith
    convertRegexFilterToStartsWithFilter(request, ColumnKeys.NAME);
    return;
  }
}
